import { ReactElement, useEffect, useState } from "react";
import { Container, Divider, Tab, Tabs, Typography } from "@mui/material";
import AbaAssinatura from "./assinatura";
import AbaFaturas from "./faturas";
import AbaPerfil from "./perfil";
import { TabContext, TabPanel } from "@mui/lab";
import AbaPreferencias from "./preferencias";
import { useLocation, useNavigate } from "react-router-dom";
import { useUsuario } from "../../../providers/usuarioProvider";
import { Perfil } from "../../../models/enum";
import AbaBusiness from "./business";
import AbaParceiros from "./parceiros";
import { map } from "lodash";
import {
  IconAdjustments,
  IconBriefcase,
  IconCreditCard,
  IconId,
  IconReceipt,
  IconGift,
} from "@tabler/icons-react";

export default function Conta() {
  const navigate = useNavigate();
  const [tab, setTab] = useState("perfil");
  const location = useLocation();
  const { isLoading, claims } = useUsuario();

  useEffect(() => {
    if (!!location.hash) {
      setTab(location.hash.slice(1));
    }
  }, [location]);

  let abas: {
    value: string;
    label: string;
    component: ReactElement;
    icone: ReactElement;
  }[] = [];
  if (!isLoading) {
    abas.push({
      value: "perfil",
      label: "Perfil",
      component: <AbaPerfil />,
      icone: <IconId />,
    });
    if (claims?.perfil === Perfil.CONTADOR) {
      abas.push({
        value: "business",
        label: "Escritório",
        component: <AbaBusiness />,
        icone: <IconBriefcase />,
      });
      abas.push({
        value: "parceiros",
        label: "Parceiros",
        component: <AbaParceiros />,
        icone: <IconGift />,
      });
    }
    abas.push({
      value: "preferencias",
      label: "Preferências",
      component: <AbaPreferencias />,
      icone: <IconAdjustments />,
    });
    abas.push({
      value: "assinatura",
      label: "Assinatura",
      component: <AbaAssinatura />,
      icone: <IconCreditCard />,
    });
    abas.push({
      value: "faturas",
      label: "Faturas",
      component: <AbaFaturas />,
      icone: <IconReceipt />,
    });
  }

  return (
    <Container maxWidth="md" disableGutters sx={{ py: 4 }}>
      <Typography variant="eyebrow" color="text.secondary" component="p" mb={1}>
        Conta
      </Typography>
      <TabContext value={tab}>
        <Tabs
          value={tab}
          onChange={(_event, value) => {
            setTab(value);
            navigate(`${location.pathname}#${value}`, { replace: true });
          }}
          // Indicador e aba ativa em accent-ink: o accent sólido não alcança
          // os 3:1 do WCAG sobre superfície escura.
          sx={(theme) => ({
            minHeight: 44,
            "& .MuiTab-root": {
              minHeight: 44,
              color: theme.palette.text.secondary,
              "&.Mui-selected": { color: theme.palette.accentInk },
            },
            "& .MuiTabs-indicator": {
              backgroundColor: theme.palette.accentInk,
              height: 2,
            },
          })}
        >
          {map(abas, (aba) => (
            <Tab
              key={aba.value}
              value={aba.value}
              label={aba.label}
              icon={aba.icone}
              iconPosition="start"
            />
          ))}
        </Tabs>
        <Divider />
        {map(abas, (aba, index) => (
          <TabPanel key={index} value={aba.value} sx={{ px: 0 }}>
            {aba.component}
          </TabPanel>
        ))}
      </TabContext>
    </Container>
  );
}
